export default __webpack_public_path__ + "static/media/image1grises1.ff5e284f.jpeg";